import { isSet } from '../utils/isSet';

class ValidationEngine {
    constructor(map, watch = true, validateOnAny = false, callbackOnValidated, callbackOnEachValidated, callbackonError, callbackOnEachError){
        this.map = map;
        this.watch = watch;
        this.validateOnAny = validateOnAny;
        this.callbackOnValidated = callbackOnValidated;
        this.callbackOnEachValidated = callbackOnEachValidated;
        this.callbackonError = callbackonError;
        this.callbackOnEachError = callbackOnEachError;

        this.defaultConfig = { attributes: true, childList: false, subtree: true};

        this.processValidationMap();
    }

    processValidationMap(){
        this.map.forEach((value, key, map) => {
            const nodeList = document.querySelectorAll(value.selector);

            if(!isSet(nodeList)) throw new Error(value.selector + " does not exist in document");
            
            value.nodeList = nodeList;

            if(this.watch === true) this.startWatching(nodeList, value, key);

            this.map.set(key, value);
        });
    }

    startWatching(nodeList, value, key){
        const config = this.defaultConfig;
        config.attributeFilter = value.attribute;
        config.attributeOldValue = true;

        nodeList.forEach((node) => {
            const callback = this.mutationObserverCallback;

            const observer = new MutationObserver(callback);

            observer.observe(node, config);
        });
    }

    mutationObserverCallback(mutationList, observer){
        for (const mutation of mutationList) {
            let mutatedAttributeValue = mutation.target.getAttribute(mutation.attributeName);

            console.log(mutatedAttributeValue);
        }
    }
}

/**
 * validation map
 * watch: true/false
 * validateOnAny
 * callbackOnValidated
 * callbackOnEachValidated
 */

/**
 * {
 *  selector: '', 
 *  attribute: '',
 *  type: string/date/quantity
 *  validOnAny: true/false
 * }
 */

/**
 * loop over each item in map
 * if watch is true then setup up mutationObserver
 *      else check if valid and return callback/s
 * 
 * return callbacks when all mutation observers are valid
 */

exports.ValidationEngine = ValidationEngine